<div class="chart-box" id="margin">
  <apx-chart *ngIf="chart" style="width: 50%; height: 100%;" [series]="series" [chart]="chart" [dataLabels]="dataLabels" [markers]="markers" [title]="title" [fill]="fill" [yaxis]="yaxis" [xaxis]="xaxis" [tooltip]="tooltip" [autoUpdateSeries]="true">
  </apx-chart>
  <!-- <apx-chart style="width: 100%; height: 100%;" [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis" [title]="chartOptions.title"></apx-chart> -->
</div>
